import { decodeAuthToken } from "../components/utils";
import { useAuthStore } from "../store";

const INTERNAL_DOMAINS = ["rulezero.com", "hissa.com"];

/**
 * Returns true if the currently logged-in user's email belongs to an internal
 * domain (rulezero.com / hissa.com). Uses the same logic as ScheduleSection.tsx.
 */
export function useIsInternalUser(): boolean {
  const { accessToken } = useAuthStore();
  const decodedEmail: string = accessToken
    ? decodeAuthToken(accessToken)?.emailId ?? ""
    : "";
  return INTERNAL_DOMAINS.some((domain) =>
    decodedEmail.toLowerCase().endsWith(`@${domain}`)
  );
}
